import { Typography } from "@material-tailwind/react";
import { mtProps } from "../../../util/mtProps";

const NotFoundContainer = () => {
	return (
		<div className="container p-4">
			<Typography {...mtProps} variant="h3" className="dark:text-white">
				404 - Page Not Found
			</Typography>
		</div>
	);
};

export default NotFoundContainer;
